(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloDeleteController',ModelloDeleteController);

    ModelloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modello'];

    function ModelloDeleteController($uibModalInstance, entity, Modello) {
        var vm = this;

        vm.modello = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modello.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
